import { FLOW_STEP_EVENT, FLOW_STEP_REVIEW, FLOW_STEP_VEHICLE } from 'purchase-flow/constants'

import ReviewPay from '../BookingView/components/ReviewPay'
import DateProductSelection from './DateProductSelection/DateProductSelection'
import VehicleSelection from './VehicleSelection/VehicleSelection'

const EventFlowBr = ({
    grsId,
    activeStep,
    bookingData,
    onNext,
    setDateRange,
    setEvent,
    setVehicle,
    rateVehicle,
    errorMessage,
    currentItemIndex,
    showPixPaymentMethod,
}) => (
    <div>
        {activeStep === FLOW_STEP_EVENT && (
            <DateProductSelection
                grsId={grsId}
                onNext={onNext}
                setDateRange={setDateRange}
                setProduct={setEvent}
                bookingData={bookingData}
                currentItemIndex={currentItemIndex}
            />
        )}
        {activeStep === FLOW_STEP_VEHICLE && (
            <VehicleSelection onNext={onNext} setVehicle={setVehicle} bookingData={bookingData} rate={rateVehicle} />
        )}
        {activeStep === FLOW_STEP_REVIEW && !errorMessage && (
            <ReviewPay
                grsId={grsId}
                bookingData={bookingData}
                rate={bookingData?.event}
                isEventFlow
                showPixPaymentMethod={showPixPaymentMethod}
            />
        )}
    </div>
)

export { EventFlowBr }
